/* eslint-disable max-len */
import React from 'react';
import {IconProps} from './types';

export const OnsiteAccessIconSVG: React.FC<IconProps> = ({ isWithBorder }) => {
  return (
    <svg width="42" height="42">
      <g fill="none" fillRule="evenodd">
        {isWithBorder && (
          <path
            d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
            fill="#CCCBCB"
            fillRule="nonzero"
          />
        )}
        <path d="M6 6h30v30H6z" />
        <path
          d="M31.96 15.238c-.175-.688-.864-1.088-1.553-.938-2.981.662-6.3.95-9.407.95s-6.426-.287-9.407-.95c-.69-.15-1.378.25-1.554.938-.175.7.251 1.412.94 1.575 2.017.45 4.196.762 6.263.937v15c0 .688.564 1.25 1.253 1.25s1.252-.563 1.252-1.25V26.5h2.506v6.25c0 .688.563 1.25 1.252 1.25.69 0 1.253-.563 1.253-1.25v-15c2.067-.175 4.246-.488 6.25-.938a1.29 1.29 0 0 0 .953-1.575ZM21 14a2.51 2.51 0 0 0 2.505-2.5A2.51 2.51 0 0 0 21 9a2.51 2.51 0 0 0-2.505 2.5A2.51 2.51 0 0 0 21 14Z"
          fill="#144D8E"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
